<template>
  <div>
    <common-multi-selector
      v-if="multiple"
      :data-source="dataSourceProxy"
      :value="value"
      @change="handleChange"
    />
    <common-single-selector
      v-else-if="singleMode"
      :data-source="dataSourceProxy"
      :value="value"
      @change="handleChange"
    />
    <div v-else>不支持的输入模式</div>
  </div>
</template>
<script>
import {
  MultiSelector,
  SingleSelector,
} from "@/components/excel/schema/value/mode";
import CommonMultiSelector from "@/components/selector/CommonMultiSelector";
import CommonSingleSelector from "@/components/selector/CommonSingleSelector";

import { findSource } from "@/utils/excel/ValueDataSource";
import {
  findOptionsText,
  findOptionText,
} from "@/utils/excel/CommonDataSource";
import {
  assembleCommonDisabled,
  filterCommonAllowed,
  filterCommonHidden,
} from "@/utils/excel/OptionFilter";

export default {
  name: "grid-common-selector-editor",
  components: {
    CommonSingleSelector,
    CommonMultiSelector,
  },
  props: {
    type: {
      type: Number,
    },
    text: {
      type: String,
    },
    value: {
      type: [Array, Number, String, Boolean],
    },
    mode: {
      type: Number,
    },
    options: Array,
    disabledItems: Array,
    hiddenItems: Array,
  },
  data() {
    return {
      modeValue: {
        single: SingleSelector.value,
        multi: MultiSelector.value,
      },
      dataSource: [],
    };
  },
  computed: {
    multiple() {
      return this.mode === this.modeValue.multi;
    },
    singleMode() {
      return this.mode === this.modeValue.single;
    },
    dataSourceProxy() {
      return this.filterSource(this.dataSource);
    },
  },
  watch: {
    type(type) {
      this.updateSource(type);
    },
  },
  methods: {
    async updateSource(type) {
      const source = await findSource(type);
      this.dataSource = source || [];
    },
    handleChange(value) {
      const text = this.obtainText(value);
      this.$emit("change", { value, text });
    },
    obtainText(value) {
      if (this.multiple) {
        return findOptionsText(this.dataSource, value);
      }
      return findOptionText(this.dataSource, value);
    },
    filterSource(source) {
      const { disabledItems, hiddenItems, options } = this.$props;
      const list = filterCommonAllowed(source, options);
      const filter = filterCommonHidden(list, hiddenItems);
      return assembleCommonDisabled(filter, disabledItems);
    },
  },
  mounted() {
    this.updateSource(this.type);
  },
};
</script>
